    <template>
      <div class="user-background">
        <div class="user-container px-3">
          <main class="user-main pb-3">
            <b-navbar class="user-navbar pb-0" toggleable="lg">
              <b-container fluid class="mt-2">
                <!-- Logo -->
                <b-navbar-brand href="#" class="ms-2 me-1">
                  <b-img src="/images/logo.png" height="74" alt="Lezzet Döner"></b-img>
                </b-navbar-brand>

                <!-- Hamburger menü butonu -->
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <!-- Navbar içeriği -->
                <b-collapse id="nav-collapse" is-nav>
                  <b-navbar-nav class="mb-2 mb-lg-0 mx-1 align-items-center">
                    <b-nav-item :to="{ name: 'sale' }" class="text-center mt-lg-0 mt-2 user-navbar-button"
                      :class="{ 'active': $route.name === 'sale' }">
                      Satış
                    </b-nav-item>
                    <b-nav-item :to="{ name: 'safe' }" class="text-center mt-lg-0 mt-2 user-navbar">
                      Kasa
                    </b-nav-item>
                    <b-nav-item :to="{ name: 'reports' }" class="text-center mt-lg-0 mt-2 user-navbar">
                      Gelir Gider
                    </b-nav-item>
                    <b-nav-item v-if="admin == true" :to="{ name: 'adminSafe' }"
                      class="text-center mt-lg-0 mt-2 user-navbar">
                      Yönetim Paneli
                    </b-nav-item>
                    <b-nav-item v-if="admin == false" :to="{ name: 'settings' }"
                      class="text-center mt-lg-0 mt-2 user-navbar">
                      Ayarlar
                    </b-nav-item>
                  </b-navbar-nav>

                  <!-- Sağ taraftaki kullanıcı bilgisi -->
                  <b-navbar-nav class="ml-auto mt-lg-0 mt-4">
                    <div class="d-flex align-items-center justify-content-center gap-3">
                      <div class="text-black fs-5 mb-0 mr-4" style="font-weight: 500;">
                        {{ username }} ({{ user.email }})
                      </div>

                      <i @click="logoutAction" class="fas fa-sign-out-alt" style="cursor: pointer;"></i>
                    </div>
                  </b-navbar-nav>
                </b-collapse>
              </b-container>
            </b-navbar>
            <router-view></router-view>
          </main>
        </div>
      </div>
    </template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {

  data() {
    return {
      admin: false,
    }
  },

  computed: {
    ...mapGetters(['user']),
    username() {
      return this.user ? this.user.name : '';
    },
  },
  methods: {
    ...mapActions(['getUser', 'logout']),

    logoutAction() {
      this.logout().then(() => {
        this.$router.go({ name: 'login' });
      })
    },
    setAdmin() {
      this.admin = this.user.homepage_permission == 1 ? true : false;
    }
  },
  async mounted() {
    await this.getUser()
    this.setAdmin();
  }
};
</script>
<style scoped>
.user-background {
  background-color: #F0F0F3 !important;
  min-height: 100%;
}

.user-container {
  max-width: 1024px;
  margin: 0 auto;

  font-family: 'Roboto', sans-serif !important;
}

.gap-3 {
  gap: 12px;
}

.navbar-collapse {
  background-color: #F0F0F3 !important;
}

.user-navbar {
  background-color: #F0F0F3 !important;
}

.navbar-light .user-navbar-button.active a {
  color: white !important;
  background-color: #0C6D01 !important;
}

.navbar-light .navbar-nav .nav-link {
  font-size: 15px !important;
  font-weight: 500 !important;
  color: #797676 !important;
  border-radius: 10px !important;
  box-shadow:
    -2.18px -2.18px 6.54px rgba(255, 255, 255, 1),
    2.18px 2.18px 6.54px rgba(174, 174, 205, 0.4) !important;
  margin: 0 12px !important;
  transition: all 0.3s ease !important;
  align-content: center !important;
  width: 96px;
  line-height: 1;
}


.navbar-light .navbar-nav .nav-link:hover {
  color: white !important;
  background-color: #0C6D01 !important;
}

.navbar-light .navbar-nav .nav-link:active {
  color: white !important;
  background-color: #0C6D01 !important;
}

.navbar-light .navbar-nav .nav-link:focus {
  color: white !important;
  background-color: #0C6D01 !important;
}

.navbar-light .navbar-nav .nav-link.router-link-exact-active {
  color: white !important;
  background-color: #0C6D01 !important;
}

.a.router-link-active span,
a.router-link-exact-active {
  background: #0C6D01 !important;
  color: white !important;
}

.sale-left-container {
  height: 730px;
  background-color: #F0F0F3;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 50px;
}

.sale-right-container {
  min-width: 365px;
}

.sale-left-header-button {
  font-size: 18px;
  font-weight: 500;
  color: #797676;
  height: 50px !important;
  border-radius: 10px;
  box-shadow:
    -2.18px -2.18px 6.54px rgba(255, 255, 255, 1),
    2.18px 2.18px 6.54px rgba(174, 174, 205, 0.4);
  margin: 0 12px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.sale-left-header-button:hover {
  background-color: #0C6D01;
  color: #FFFFFF;
}

.sale-left-header-button.active {
  background-color: #0C6D01;
  color: #FFFFFF;
}

.sale-card {
  width: 124px;
  height: 230px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sale-card-body {
  margin-top: 36px;
  height: 196px;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  padding-bottom: 7px;
  border-radius: 25px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  background-color: white !important;
}

.sale-card-title {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}

.sale-card-alt-title {
  font-size: 12px;
  font-weight: 400;
  color: #ACACAC;
  border-bottom: 1px solid #acacac44;
  width: 137px;
  text-align: center;
}

.sale-card-button {
  width: 137px;
  height: 34px;
  background-color: #0C6D01;
  border-radius: 17px;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sale-card-button:hover {
  background-color: #0f9b00;
}

.sale-right-container {
  padding: 0 6px;
}

.sale-right-container-alt {
  box-shadow:
    -2.18px -2.18px 6.54px rgba(255, 255, 255, 1),
    2.18px 2.18px 6.54px rgba(174, 174, 205, 0.4);
  height: 100%;
  border-radius: 10px;
  padding-top: 13px;
}

.sale-right-header-title {
  font-size: 16px;
  font-weight: 600;
  color: #01472D;
}

.sale-right-header-alt {
  background-color: #E6EDEA;
  padding: 5px 10px;
}

.sale-right-header-alt-1 {
  font-size: 12px;
  font-weight: 400;
  color: #01472D;
  cursor: pointer;
}

.sale-right-header-alt-2 {
  font-size: 14px;
  font-weight: 600;
  color: #01472D;
  margin-left: 80px;
}

.sale-right-basket-item {
  background-color: #E6EDEA;
  color: #FFFFFF;
  border-radius: 10px;
  padding: 2px 10px;
  margin-top: 8px;
  height: 76px;
}

.sale-right-basket-item-button-container {
  width: 38px;
  border-radius: 20px;
}

.sale-right-basket-item-button {
  font-size: 18px;
  color: #4A5C2F;
  cursor: pointer;

}

.sale-right-basket-item-counter {
  background-color: #01472D;
  border-radius: 50%;
  padding: 0 8px;
  color: #FFFFFF;
}

.sale-right-basket-item-info-title {
  font-size: 12px;
  font-weight: 600;
  color: #01472D;
}

.sale-right-basket-item-info-alt-title-1 {
  font-size: 12px;
  font-weight: 500;
  color: #686868;
}

.sale-right-basket-item-info-alt-title-2 {
  font-size: 12px;
  font-weight: 500;
  color: #ACACAC;
}

.sale-right-basket-item-price {
  font-size: 20px;
  font-weight: 700;
  color: #01472D;
}

.sale-right-footer-button {
  box-shadow:
    -2.18px -2.18px 6.54px rgba(255, 255, 255, 1),
    2.18px 2.18px 6.54px rgba(174, 174, 205, 0.4);
  padding: 10px 0;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #01472D;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sale-right-footer-button:hover {
  background-color: #0C6D01;
  color: #FFFFFF;
}

.sale-right-footer-button:hover svg {
  fill: #fff !important;
}

.sale-right-footer-result-title {
  font-size: 14px;
  font-weight: 500;
  color: #797676;
}

.sale-right-footer-result-price {
  font-size: 14px;
  font-weight: 500;
  color: #313030;
}

.sale-right-footer-result {
  border-top: 1px dashed #AEAEB2;
  border-bottom: 1px dashed #AEAEB2;
  padding: 10px 0;
}

.sale-right-footer-result-button {
  border-radius: 10px;
  background-color: #0C6D01;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 500;
  padding: 12px 0;
  text-align: center;
  cursor: pointer;
  margin-top: 14px;
  transition: all 0.3s ease;
}

.sale-right-footer-result-button:hover {
  background-color: #0f9b00;
}


.sale-right-basket-container {
  max-height: 430px;
  overflow-y: auto;
}

.nav-link {
  height: 45px
}

.navbar-collapse {
  background-color: #F0F0F3 !important;
  position: relative;
}
</style>
